export const ROOM_LOOKUP = {
    jabba: {
      name: "Jabba's Palace",
      resourceId: process.env.REACT_APP_ROOM_JABBAS_PALACE_ID,
    },
    naboo: {
      name: "Naboo",
      resourceId: process.env.REACT_APP_ROOM_NABOO_ID,
    },
    xwing: {
        name: "X-Wing",
        resourceId: process.env.REACT_APP_ROOM_X_WING_ID,
    },
    ywing: {
        name: "Y-Wing",
        resourceId: process.env.REACT_APP_ROOM_Y_WING_ID,
    },
    falcon: {
        name: "Millenium Falcon",
        resourceId: process.env.REACT_APP_ROOM_MILLENIUM_FALCON_ID,
    },
    outlander: {
        name: "Outlander Club",
        resourceId: process.env.REACT_APP_ROOM_OUTLANDER_CLUB_ID,
    }
};